import { Heading, SimpleGrid, Stack, SvgIcon, Text, useText } from "@sveabank/cc-common";
import Content from "../../components/content";

const PageFooter = () => {
	const [t, texts] = useText();

	return (
		<footer className="bg-background-dark flex min-h-[232px] justify-center">
			<div className="bg-background-dark laptop:max-w-(--breakpoint-laptop) laptop:px-0 w-full flex-row px-4 pt-14 pb-6">
				<Content>
					<SimpleGrid cols={3} gap={8}>
						<Stack align="start">
							<SvgIcon imageSrc="LOGO" height={32} className="text-text-contrast" />
						</Stack>
						<Stack gap={4} component="section">
							<Heading.H3 className="text-text-contrast">
								{t(texts.pageFooter.address.heading)}
							</Heading.H3>
							<Text className="text-text-contrast">{t(texts.pageFooter.address.address)}</Text>
						</Stack>
						<Stack gap={4} component="section">
							<Heading.H3 className="text-text-contrast">
								{t(texts.pageFooter.customerService.heading)}
							</Heading.H3>
							<Text className="text-text-contrast">
								{t(texts.pageFooter.customerService.phone)}
							</Text>
							<Text className="text-text-contrast">{t(texts.pageFooter.customerService.open)}</Text>
						</Stack>
						<Text className="text-text-contrast text-sm">
							{t(texts.pageFooter.copyright, new Date().getFullYear().toString())}
						</Text>
					</SimpleGrid>
				</Content>
			</div>
		</footer>
	);
};

export default PageFooter;
